import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useStyles } from '../../adminStyles';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import { getProjectList } from '../../../../redux/projects/projectsActions';
import { notify } from '../../../../redux/utils/notifications/notifications';
import { getAppUserList } from '../../../../redux/appUsers/appUserActions';
import {
  Container,
  Grid,
  Checkbox,
  MenuItem,
  InputLabel,
  Select,
  FormControlLabel,
  FormControl,
  Button,
  TextField,
} from '@material-ui/core';
import {
  getAppUser,
  clearAppUser,
  saveAppUser,
  getVendors,
  getJobTitles,
  getClientManagers,
  getOnboardingTypes
} from '../../../../redux/appUsers/appUserActions';
import { DB_DATE_FORMAT, EMPLOYEE_TYPE, USER_ROLE } from '../../../../redux/constants';

import ProjectSelection from './ProjectsSelection';

const TextMaskCustom = props => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        '1',
        '-',
        /[1-9]/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholderChar={'\u2000'}
      placeholder='1-555-555-5555'
    />
  );
};

TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

const TimesheetUserDetails = props => {
  const { container, dropdown } = useStyles();
  document.title = 'Sciata User Details';
  const dispatch = useDispatch();
  const projectList = useSelector(state => state.projects.allProjects || []);
  const user = useSelector(state => state.appUsers.selectedUser || {});
  const users = useSelector(state => state.appUsers.usersList || []);
  const [userId, setUserId] = useState(0);
  const [projects, setProjects] = useState([]);
  const jobTitles = useSelector(state => state.appUsers.jobTitles || []);
  const [record, setRecord] = useState({});
  const [vendorList, setVendorList] = useState([]);
  const [clientManagers, setClientManagers]=useState([]);
  const [onboardingTypes,setOnboardingTypes]=useState([]);

  useEffect(() => {
    let uid = 0;
    try {
      uid = parseInt(props.match.params.uid);
    } catch (e) {
      uid = 0;
    }
    setUserId(uid);
    bindProjects();
    bindUser(uid);
    bindVendors();
    bindJobTitles();
    bindClientManagers();
    bindOnboardingTypes();
  }, []);

  const bindJobTitles = () => dispatch(getJobTitles());
  const bindProjects = () => dispatch(getProjectList());  
  const bindUser = id => dispatch(getAppUser(id));

  const bindVendors = async () => {
    let _vendorList = await dispatch(getVendors());
    setVendorList(_vendorList);
  };
  const bindClientManagers= async()=>{
    let _clientManagers = await dispatch(getClientManagers());
    setClientManagers(_clientManagers);
  }
  const bindOnboardingTypes= async()=>{
    let _types = await dispatch(getOnboardingTypes());
    setOnboardingTypes(_types);
  }

  useEffect(() => {
    let userProjects = user.projects || [];
    setProjects(
      (projectList || []).map(project => {
        const idx = userProjects.findIndex(uProj => {
          return uProj.code === project.projectId;
        });

        if (idx >= 0) {
          return {
            ...project,
            ...userProjects[idx],
            isSelected: true,
          };
        } else {
          return {
            ...project,
            isDefault: false,
            isSelected: false,
            startDate: null,
            endDate: null,
            onboardingTypeId:'',
            milestoneRecId:''
          };
        }
      })
    );

    if (userId <= 0) {
      let record = {};
      record['holiday'] = 0;
      record['vacation'] = 0;
      record['sick'] = 0;
      record['active'] = 1;
      record['vendor'] = {};
      record['managerId'] = 0;
      record['role'] = '';
      record['jobTitleId'] = 0;
      setRecord(record);
    } else {
      setRecord(user);
    }
  }, [projectList, user]);

  const onFieldChange = e => {
    let _record = { ...record };
    _record[e.target.name] = e.target.value;
    setRecord(_record);
  };

  const handleSave = async () => {
    if (!validateForm()) {
      return false;
    }

    let body = JSON.parse(JSON.stringify(record));

    body['middleName'] = body['middleName'] || '';

    let selectedProjects = projects.slice().filter(item => {
      return item.isSelected === true;
    });

    selectedProjects.map(item => (item.code = item.projectId));

    if (selectedProjects.length > 0) {
      if (selectedProjects.some(item => item.isDefault === true)) {
        body.projects = selectedProjects;

        if (Object.keys(body.vendor || {}).length <= 0) {
          body.vendor = undefined;
        }
        const result = await dispatch(saveAppUser(body, userId));

        if (result) {
          dispatch(clearAppUser());
          props.history.push('/admin/users');
        }
      } else {
        notify('error', 'Please select at lease one project as default project');
      }
    } else {
      notify('error', 'Please select at least one project.');
    }
  };

  const existingUser = () => {
    return users.find(user => {
      return record.emailId === user.emailId || record.empId === user.empId;
    });
  };

  const validateForm = () => {
    if ((record.firstName || '').trim().length <= 0) {
      notify('error', 'Please enter first name');
      return false;
    }
    if ((record.lastName || '').trim().length <= 0) {
      notify('error', 'Please enter last name');
      return false;
    }
    if ((record.emailId || '').trim().length <= 0) {
      notify('error', 'Please enter email id');
      return false;
    }
    if (!record.emailId.includes('@') || !record.emailId.includes('.')) {
      notify('error', 'Invalid email');
      return false;
    }
    if ((record.empId || '').trim().length <= 0) {
      notify('error', 'Please enter employee Id');
      return false;
    }
    if ((record.role || '').trim().length <= 0) {
      notify('error', 'Please select user role');
      return false;
    }
    if ((record.role || '').trim().length <= 0) {
      notify('error', 'Please select employment type');
      return false;
    }
    if (!record.jobTitleId) {
      notify('error', 'Please select title');
      return false;
    }
    return true;
  };

  const bindUsers = () => dispatch(getAppUserList());

  useEffect(() => {
    bindUsers();
  }, []);

  const renderManagerList = () => {
    let managers = users.filter(user => user.role === 'manager') || [];

    return managers.map(manager => (
      <MenuItem value={manager.id}>{`${manager.firstName} ${manager.lastName}`}</MenuItem>
    ));
  };
  const renderClientManagerList = () => {
    return clientManagers.map(manager => (
      <MenuItem value={manager.id}>{`${manager.name}`}</MenuItem>
    ));
  };

  const handleManagerIdVal = () => {
    if (record.role === '' || record.role === 'manager') {
      record.managerId = 0;
      return record.managerId || 0;
    }
    return record.managerId || 0;
  };

  return (
    <Container className={container}>
      <Grid>
        <h1>User Details</h1>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <TextField
                  variant='outlined'
                  required
                  id='firstName'
                  name='firstName'
                  label='First name'
                  fullWidth
                  value={record.firstName || ''}
                  onChange={onFieldChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  variant='outlined'
                  id='middleName'
                  name='middleName'
                  label='Middle name'
                  fullWidth
                  autoComplete='middleName'
                  value={record.middleName || ''}
                  onChange={onFieldChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  variant='outlined'
                  required
                  id='lastName'
                  name='lastName'
                  label='Last name'
                  fullWidth
                  autoComplete='lastName'
                  value={record.lastName || ''}
                  onChange={onFieldChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  variant='outlined'
                  required
                  id='emailId'
                  name='emailId'
                  label='Email Id'
                  fullWidth
                  autoComplete='emailId'
                  value={record.emailId || ''}
                  onChange={onFieldChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <TextField
                    value={record.mobile || ''}
                    name='mobile'
                    label='Mobile'
                    onChange={onFieldChange}
                    variant='outlined'
                    id='formatted-text-mask-input'
                    InputProps={{
                      inputComponent: TextMaskCustom,
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth style={{ margin: '0px' }}>
                  <InputLabel variant='outlined' id='label'>
                    Title*
                  </InputLabel>
                  <Select
                    labelId='label'
                    label='Title*'
                    name='jobTitleId'
                    variant='outlined'
                    value={record.jobTitleId || ''}
                    id='jobTitle'
                    onChange={onFieldChange}
                    required
                  >
                    {jobTitles.map(title => {
                      return <MenuItem value={title.id}>{title.jobTitle}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  variant='outlined'
                  id='empId'
                  name='empId'
                  label='Employee Id*'
                  value={record.empId || ''}
                  fullWidth
                  onChange={onFieldChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth style={{ margin: '0px' }}>
                  <InputLabel variant='outlined' id='select-label-role'>
                    Role*
                  </InputLabel>
                  <Select
                    name='role'
                    id='role'
                    label='Role*'
                    variant='outlined'
                    value={record.role || ''}
                    onChange={onFieldChange}
                    required
                    labelId='select-label-role'
                  >
                    {Object.keys(USER_ROLE).map(item => {
                      return <MenuItem value={USER_ROLE[item]}>{item}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth style={{ margin: '0px' }}>
                  <InputLabel variant='outlined' id='select-label-usertype'>
                    Employment Type*
                  </InputLabel>
                  <Select
                    labelId='select-label-usertype'
                    variant='outlined'
                    label='Employment Type*'
                    name='userType'
                    value={record.userType || ''}
                    id='userType'
                    onChange={onFieldChange}
                    required
                  >
                    {Object.keys(EMPLOYEE_TYPE).map(item => {
                      return <MenuItem value={EMPLOYEE_TYPE[item]}>{item}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>
              {record.userType === EMPLOYEE_TYPE.Contractor ? (
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth style={{ margin: '0px' }}>
                    <InputLabel id='select-label-vendor'>Vendor*</InputLabel>
                    <Select
                      labelId='select-label-vendor'
                      label='Vendor*'
                      name='vendorId'
                      variant='outlined'
                      value={(record.vendor || {}).vendorId || ''}
                      id='vendorId'
                      onChange={e => {
                        let _record = { ...record };
                        _record['vendor'] = {
                          vendorId: e.target.value,
                        };
                        setRecord(_record);
                      }}
                      required
                    >
                      {vendorList.map(item => {
                        return (
                          <MenuItem value={item.vendorId}>{item.vendorName}</MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
              ) : null}
              {
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth style={{ margin: '0px' }}>
                    <InputLabel variant='outlined' id='select-label-managerId'>
                      Manager*
                    </InputLabel>
                    <Select
                      labelId='select-label-managerId'
                      label='Manager*'
                      name='managerId'
                      variant='outlined'
                      value={handleManagerIdVal() || ''}
                      id='manager'
                      onChange={onFieldChange}
                      disabled={record.role === 'manager' || record.role === ''}
                    >
                      {renderManagerList()}
                    </Select>
                  </FormControl>
                </Grid>
              }
              <Grid item xs={12} sm={4}>
                  <FormControl fullWidth style={{ margin: '0px' }}>
                    <InputLabel variant='outlined' id='select-label-clientManagerId'>
                      Client Manager*
                    </InputLabel>
                    <Select
                      labelId='select-label-clientManagerId'
                      label='Client Manager*'
                      name='clientManagerId'
                      variant='outlined'
                      value={record.clientManagerId || ''}
                      id='clientmanager'
                      onChange={onFieldChange}
                    >
                      {renderClientManagerList()}
                    </Select>
                  </FormControl>
                </Grid>
              <Grid item xs={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={record.active === 1 ? true : false}
                      name='active'
                      onChange={e => {
                        let _record = { ...record };
                        _record['active'] = e.target.checked ? 1 : 0;
                        setRecord(_record);
                      }}
                      color='primary'
                    />
                  }
                  label={record.active === 1 ? 'Active' : 'Inactive'}
                />
              </Grid>
            
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <ProjectSelection
                  list={projects || []}
                  onboardingTypes={onboardingTypes||[]}
                  onSelectProject={project => {
                    const idx = projects.findIndex(item => {
                      return item.projectId === project.projectId;
                    });
                    if (idx >= 0) {
                      projects[idx] = project;
                      setProjects(projects.slice());
                    }
                  }}
                  onProjectDatesChange={(id, key, date) => {
                    let _projectList = [...projects];
                    _projectList.map((item, k) => {
                      if (item.projectId === id) {
                        item.isDefault = true;
                        item[key] = date.format(DB_DATE_FORMAT);
                      } else {
                        item.isDefault = false;
                        item[key] = null;
                      }
                    });
                    setProjects(_projectList);
                  }}
                  onProjectDefaultChange={id => {
                    let _projectList = projects.slice();
                    _projectList.map((item, k) => {
                      if (item.projectId === id) {
                        item.isDefault = true;
                      } else {
                        item.isDefault = false;
                      }
                    });
                    setProjects(_projectList);
                  }}
                  onProjectOnboardTypeChange={(id,e)=>{
                    let _projectList = projects.slice();
                    _projectList.map((item, k) => {
                      if (item.projectId === id) {
                        item[e.target.name] = e.target.value;
                      } 
                    });
                    setProjects(_projectList);
                  }}
                  onProjectMilestoneChange={(id,e)=>{
                    let _projectList = projects.slice();
                    _projectList.map((item, k) => {
                      if (item.projectId === id) {
                        item[e.target.name] = e.target.value;
                      } 
                    });
                    setProjects(_projectList);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} align='right' style={{ marginTop: 10 }}>
          <Button
            variant='contained'
            color='secondary'
            style={{ marginRight: '10px' }}
            onClick={() => {
              dispatch(clearAppUser());
              props.history.push('/admin/users');
            }}
          >
            Cancel
          </Button>
          <Button variant='contained' color='primary' onClick={handleSave}>
            Save
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default withRouter(TimesheetUserDetails);
